import React from 'react'
import logo from '../../Assets/images/logo/SenicLogo.png'
import Modal from 'react-bootstrap/Modal';
import { AiOutlineClose } from 'react-icons/ai'
export default function ModalFactor({ selectModalIndex, index, setSelectModalIndex, item }) {
    return (
        <Modal show={selectModalIndex == index ? true : false} >
            <div className='factor'>
                <div className='factor-header'>
                    <h3>فاکتور خرید شما</h3>
                    <AiOutlineClose onClick={() => setSelectModalIndex(-1)} />
                </div>
                <table>
                    <tr>
                        <td className='factor-li'>نام گیرنده :</td>
                        <td>{item.user.username}</td>
                    </tr>
                    <tr>
                        <td className='factor-li'>کد پیگیری :</td>
                        <td>{item.trackingCode}</td>
                    </tr>
                    <tr>
                        <td className='factor-li'>تاریخ :</td>
                        <td> {new Date(
                            item.registerDate
                        ).toLocaleDateString("fa-IR")}
                        </td>
                    </tr>
                    <tr>
                        <td className='factor-li'>آدرس :</td>
                        <td> {item.address?.fullAddress}
                        </td>
                    </tr>
                    <tr>
                        <td className='factor-li'> استان / شهر :</td>
                        <td> {item.address?.province} / { item.address?.city}
                        </td>
                    </tr>
                    <tr>
                        <td className='factor-li'> صاحب ملک :</td>
                        <td> {item.address?.owner}
                        </td>
                    </tr>
                    <tr>
                        <td className='factor-li'> شماره همراه :</td>
                        <td> {item.address?.phoneNumber}
                        </td>
                    </tr>
                    <tr>
                        <td className='factor-li'> کد پستی :</td>
                        <td> {item.address?.postalCode}
                        </td>
                    </tr>
                </table>
                <div className='factor-footer'>
                    <img src={logo} alt="سه نیک | سازمان علمی آموزشی " />
                    <h3>سازمان علمی آموزشی سنیک</h3>
                </div>
            </div>
        </Modal>
    )
}
